import { Button, Modal } from 'react-bootstrap';

interface IOwnProps {
  title?: string;
  children?: React.ReactNode;
  show: boolean;
  handleCancel: () => void;
  handleProceed: () => void;
}
export const Confirm: React.FC<IOwnProps> = (props: IOwnProps) => {
  return (
    <Modal
      show={props.show}
      onHide={props.handleCancel}
      backdrop="static"
      keyboard={false}
    >      
      <Modal.Header className='bg-danger-subtle'>
        <Modal.Title>{props.title ?? 'Confirmation'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.handleCancel}>Cancel</Button>
        <Button variant="primary" onClick={props.handleProceed}>Proceed</Button>
      </Modal.Footer>
    </Modal>
  );
};